<template>
	<svg :style="{ width, height }" aria-hidden="true">
		<use :xlink:href="iconNames" :fill="color" />
	</svg>
</template>

<script>
export default {
	name: 'SvgIcon',
	props: {
		iconName: {
			type: String,
			required: true,
		},
		className: {
			type: String,
		},
		//   图标的颜色
		color: {
			type: String,
			default: '',
		},
		//   接收父组件传递过来图标的宽高
		width: {
			type: String,
			default: '16px',
		},
		height: {
			type: String,
			default: '16px',
		},
	},
	computed: {
		iconNames() {
			return `#icon-${this.iconName}`
		},
	},
}
</script>

<style scoped></style>
